// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-control h2[data-v-2100d501]{padding-top:2px}.personalize-img[data-v-2100d501]{margin-left:-2rem}.personalize-text[data-v-2100d501]{text-overflow:scale}p[data-v-2100d501]{font-size:1.3rem;line-height:1.3}", ""]);
// Exports
module.exports = exports;
